<template>
    <div class="w-100">

        <div class="page-header" :class="{ 'active' : showPageHeader }">
            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>
        </div>

        <router-link tag="div" class="page-back-link" :class="{ 'tiny' : showPageHeader }" :to="linkTo('/cards')">
            <img src="/images/card/page-back-btn-icon.svg">
        </router-link>

        <button class="btn btn-primary btn-register" :class="{ 'show' : showRegisterBtn }" @click="openCustomModal(card)" v-if="card && card.isValid && card.punchesLeft !== 0">
            <img src="/images/card/register-button-icon.svg">
            <span v-if="card.product_area_id == 2">Registrera pass</span>
            <span v-else>Registrera behandling</span>
        </button>

        <transition name="modal">
            <modal-punch
                :card="modal_card"
                @close="() => {
                    modal_card = null
                    fetcherFetch()
                    $refs.cardTreatments.fetcherFetch()
                    closeCustomModal()
                }"
                v-if="modal_card !== null"
            />
        </transition>

        <transition name="modal">
            <router-view></router-view>
        </transition>

        <div class="page-body" style="min-height:calc(100vh - 100px);">

            <div class="container-fluid">

                <div class="placeholder-glow w-100" :class="{ 'd-none' : fetcher.initialized }">

                    <span class="placeholder bg-info col-24 mb-4 rounded-1" style="height: 48px;"></span>
                    <span class="placeholder bg-info col-12 mb-10 rounded-1" style="height: 48px;"></span>

                    <span class="placeholder bg-info col-12 mb-3 rounded-1" style="height: 24px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-10 rounded-2" style="height: 80px;"></span>

                </div>

                <div v-if="fetcher.initialized">

                    <h1 :class="{ 'text-dark' : !card.isValid || card.punchesLeft == 0 }">{{ pageTitle }}</h1>
                    <h3 class="mb-1"><div class="badge rounded-1 fw-normal" style="background-color: #777;" v-if="!card.isValid">Klippkortet har utgått</div></h3>
                    <p class="mb-10">
                        <span v-if="fetcher.initialized">
                            Giltigt <span v-if="card.is_gift">{{ card.hidden_to }}</span><span v-else>{{ card.created_at }}</span> - {{ card.valid_to }}<br>
                            <span v-if="card.product_area_id == 2">{{ card.punchesLeft }} / {{ card.punches_total }} träningspass återstår</span>
                            <span v-else>{{ card.punchesLeft }} / {{ card.punches_total }} behandlingar återstår</span>
                        </span>
                    </p>

                    <div v-if="card.isValid">

                        <h2 class="mb-3" :class="{ 'text-dark' : card.punchesLeft == 0 }">Återstående ({{ card.punchesLeft }})</h2>

                        <p class="mb-10" v-if="card.punchesLeft == 0">
                            <span v-if="card.product_area_id == 2">Du har använt alla träningspass.</span>
                            <span v-else>Du har använt alla behandlingar.</span>
                        </p>

                        <transition-group class="list" name="treatment-list" tag="div" v-else>

                            <div class="list-item treatment" :key="'atreatment'+n" v-for="n in card.punchesLeft"
                                 @click="modal_card = card">
                                <div class="d-flex align-items-center">
                                    <div class="list-icon">
                                        <div class="ratio ratio-1x1">
                                            <div>
                                                <div class="icon stamp"><img src="/images/card/stamp.svg"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="mb-0">{{ productAreaName(card.product_area_id) }} {{ card.product.duration.minutes }} minuter</h4>
                                </div>
                            </div>

                        </transition-group>

                    </div>

                    <card-treatments ref="cardTreatments" :card="card" v-if="card.punches_used > 0" />

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'
import ModalPunch from '../shared/modal-punch'
import CardTreatments from './card-treatments'
import jQuery from 'jquery'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {
        ModalPunch,
        CardTreatments
    },

    data () {
        return {
            showPageHeader: false,
            modal_card: null,
            card: null,
            fetcher: {
                autoFill: [
                    'card'
                ]
            },

            registerModalVisible: false,
            clinicModalVisible: false,

            registeringStep2: false,
            loadingRegistering: false,
            registeringError: false,
            registeringCode: '',
            showRegisteredTreatment: false,

            currentDate: '',
            showRegisterBtn: false,
        }
    },
    mounted() {
        setTimeout(() => {
          this.showRegisterBtn = true
        }, 250);
    },
    unmounted() {
        this.showRegisterBtn = false
    },
    computed: {
        fetcherUrl () {
            return '/cards/' + this.$route.params.card
        },
        pageTitle () {
            if (!this.fetcher.initialized) {
                return 'Klippkort'
            }
            return this.productAreaName(this.card.product_area_id) + ' ' + this.card.punches_total + 'x' + this.card.product.duration.minutes + ' min'
        }
    },

    methods: {

        openCustomModal (card) {
            this.modal_card = card
            jQuery('html').addClass('modal-open')
        },

        closeCustomModal () {
            jQuery('html').removeClass('modal-open')
        }

    }
}
</script>
<style type="text/css">
/* --- Transition modal --- */
.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 400ms ease-out;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, 100%);
}

/* --- Transition treatments list --- */
.treatment-list-enter-active, .treatment-list-leave-active
{
    transition:margin 750ms ease, padding 750ms ease, max-height 750ms ease, transform 1000ms ease;
    overflow: hidden;
}
.treatment-list-enter,
.treatment-list-leave-to {
  max-height: 0px;
  margin:0;
  padding:0;
  transform: scale(1,0);
}
.treatment-list-enter-to,
.treatment-list-leave {
  max-height: 120px;
}
</style>
